import {COLUMN_TYPE, RegistryImportSettingsProps} from 'bulk-import/SpreadsheetBulkImportConstants';
import {FrontendLabelingStrategy, LABELING_STRATEGIES_REQUIRING_NAME} from 'constants/RegistryConstants';

export function getLabelColumns({
  inOrgCollection,
  inUserCollection,
  labelingStrategy,
  trialSubjectLabelingStrategy,
}: RegistryImportSettingsProps): Array<COLUMN_TYPE> {
  const labelColumns: Array<COLUMN_TYPE> = [];

  if (labelingStrategy) {
    if (labelingStrategy === FrontendLabelingStrategy.CONVERT_IDS) {
      if (inUserCollection) {
        labelColumns.push(COLUMN_TYPE.MY_COLLECTION_ID);
      }
      if (inOrgCollection) {
        labelColumns.push(COLUMN_TYPE.ORG_COLLECTION_ID);
      }
    } else if (LABELING_STRATEGIES_REQUIRING_NAME.includes(labelingStrategy)) {
      labelColumns.push(COLUMN_TYPE.FILENAME);
    }
  }

  if (trialSubjectLabelingStrategy) {
    if (trialSubjectLabelingStrategy === FrontendLabelingStrategy.CONVERT_IDS) {
      if (inUserCollection) {
        labelColumns.push(COLUMN_TYPE.TRIAL_SUBJECT_MY_COLLECTION_ID);
      }
      if (inOrgCollection) {
        labelColumns.push(COLUMN_TYPE.TRIAL_SUBJECT_ORG_COLLECTION_ID);
      }
    } else if (LABELING_STRATEGIES_REQUIRING_NAME.includes(trialSubjectLabelingStrategy)) {
      labelColumns.push(COLUMN_TYPE.TRIAL_SUBJECT_NAME);
    }
  }

  return labelColumns;
}
